import baseAxios from 'axios';

import { TOUR_BE_API, WIDGET_API } from '../commons/constants';

export const baseURL =
  process.env.REACT_APP_BE_API || `${window.location.protocol}//${window.location.host}`;

const axios = baseAxios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export default axios;

export const vt360Axios = baseAxios.create({
  baseURL: TOUR_BE_API || `${window.location.protocol}//${window.location.host}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const widgetAxios = baseAxios.create({
  baseURL: WIDGET_API || `${window.location.protocol}//${window.location.host}`,
  headers: {
    'Content-Type': 'application/json',
  },
});
